import Line from '@/assets/icons/line.svg'
import CompanyHistoryImage1 from '@/assets/imgs/company-history-1.svg'
import CompanyHistoryImage2 from '@/assets/imgs/company-history-2.svg'
import {
  fadeLeft,
  fadeRight,
  staggerContainer,
} from '@/core/constants/animations'
import { Motion } from '@/core/ui/atoms/motion'

export const CompanyHistory = () => {
  return (
    <Motion
      type='div'
      className='relative md:mt-32'
      variants={staggerContainer}
      initial='initial'
      whileInView='animate'
      viewport={{ once: true, amount: 0.3 }}
    >
      <Line
        className={`absolute -z-50 hidden lg:-top-16 lg:block xl:-top-10 ltr:-left-36 rtl:-right-36 rtl:-scale-x-90`}
      />
      <div className='lg:ms-44'>
        <div className='flex flex-col justify-center gap-7 sm:flex-row'>
          <Motion
            type='div'
            className='sm:w-1/2'
            variants={fadeLeft.variants}
            transition={fadeLeft.transition}
            initial='initial'
            whileInView='animate'
            viewport={{ once: true }}
          >
            <CompanyHistoryImage1 className='border-grey-2 w-full rounded-lg border-2 border-solid' />
          </Motion>
          <Motion
            type='div'
            className='sm:w-1/2'
            variants={fadeRight.variants}
            transition={fadeRight.transition}
          >
            <CompanyHistoryImage2 className='border-grey-2 w-full rounded-lg border-2 border-solid' />
          </Motion>
        </div>
      </div>
    </Motion>
  )
}
